import { en } from "./en";
import { pt } from "./pt";

export const content = { en, pt };
